"use client";

import Link from "next/link";
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";

export default function Navbar() {
  const { data: session } = useSession();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-[#050505]/80 backdrop-blur-xl border-b border-white/5 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link href="/" className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-emerald-500 shadow-[0_0_20px_rgba(16,185,129,0.3)] flex items-center justify-center font-bold text-white tracking-tighter">
              S
            </div>
            <span className="text-xl font-bold tracking-tight text-white hidden sm:block">Stratos</span>
          </Link>
          
          {/* Global Marketing Navigation Links */}
          <div className="hidden md:flex items-center gap-6">
            <Link href="/ai" className="text-sm font-medium text-slate-400 hover:text-white transition-colors">
              Machine Learning
            </Link>
            
            {/* Company Dropdown */}
            <div className="relative group">
              <button className="text-sm font-medium text-slate-400 hover:text-white transition-colors flex items-center gap-1 py-4">
                Company
                <svg className="w-4 h-4 text-slate-500 group-hover:text-white transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
              </button>
              
              {/* Dropdown Menu (hidden by default, visible on group-hover) */}
              <div className="absolute top-full left-1/2 -translate-x-1/2 w-56 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform origin-top translate-y-2 group-hover:translate-y-0 z-50">
                <div className="bg-slate-900 border border-white/10 rounded-xl shadow-2xl p-2 flex flex-col gap-1">
                  <Link href="/about" className="block px-4 py-2 text-sm text-slate-300 hover:bg-white/5 hover:text-white rounded-lg transition-colors">
                    About Us
                  </Link>
                  <Link href="/security" className="block px-4 py-2 text-sm text-slate-300 hover:bg-white/5 hover:text-white rounded-lg transition-colors">
                    Security
                  </Link>
                  <Link href="/community" className="block px-4 py-2 text-sm text-slate-300 hover:bg-white/5 hover:text-white rounded-lg transition-colors">
                    Community
                  </Link>
                  <Link href="/knowledge-base" className="block px-4 py-2 text-sm text-slate-300 hover:bg-white/5 hover:text-white rounded-lg transition-colors">
                    Knowledge Base
                  </Link>
                  <Link href="/affiliate" className="block px-4 py-2 text-sm text-slate-300 hover:bg-white/5 hover:text-white rounded-lg transition-colors">
                    Affiliate Program
                  </Link>
                </div>
              </div>
            </div>

            <Link href="/pricing" className="text-sm font-medium text-slate-400 hover:text-white transition-colors">
              Pricing
            </Link>
            <Link href="/signal-routing" className="text-sm font-medium text-slate-400 hover:text-white transition-colors">
              Signal Routing
            </Link>
            <Link href="/guide" className="text-sm font-medium text-slate-400 hover:text-white transition-colors">
              Setup Guide
            </Link>
          </div>
        </div>

        <div className="flex items-center gap-4 sm:gap-6">
          {mounted && session ? (
            <Link href="/dashboard" className="text-sm font-semibold text-white bg-white/10 hover:bg-white/20 px-6 py-2.5 rounded-full transition-all border border-white/10">
              Enter Dashboard →
            </Link>
          ) : (
            <>
              <Link href="/login" className="text-sm font-medium text-slate-300 hover:text-white transition-colors">
                Sign In
              </Link>
              <Link href="/register" className="text-sm font-semibold text-black bg-white hover:bg-slate-200 px-4 sm:px-6 py-2.5 rounded-full transition-all shadow-[0_0_20px_rgba(255,255,255,0.2)]">
                Get Started
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
